<template>
  <div class="container">
    <div class="row contact-form">
      <div class="col-lg-4 col-12 slogan">
        <h1 class="title">
          {{$t('slogan')}}
        </h1>
        <i role="img" aria-label="Spring" id="spring-logo"></i>
      </div>
      <div class="col-lg-1 col-0"></div>
      <div class="col-lg-7 col-12">
        <p>
          {{$t('description')}}
          <a class="email" href="mailto:hello@fontanelabs.de">
          hello@fontanelabs.de</a>.
        </p>
        <form id="contact" method="post" action="https://api.fontanelabs.de/contact" @submit="onSubmit">
          <div class="form-group">
            <label for="contactName">{{$t('contact.name.label')}}</label>
            <input name="name" type="text" class="form-control" id="contactName"
            :placeholder="$t('contact.name.placeholder')" required>
          </div>
          <div class="form-group">
            <label for="contactEmail">{{$t('contact.email.label')}}</label>
            <input name="email" type="email" class="form-control" id="contactEmail"
            aria-describedby="emailHelp" :placeholder="$t('contact.email.placeholder')" required>
            <small id="emailHelp" class="form-text text-muted">
              {{$t('contact.email.help')}}
              <router-link to="/privacy-policy">{{$t('contact.email.privacy')}}</router-link>.
            </small>
          </div>
          <div class="form-group">
            <label for="contactFreeText">{{$t('contact.message.label')}}</label>
            <textarea name="message" class="form-control" id="contactFreeText"
            rows="3" :placeholder="$t('contact.message.placeholder')"></textarea>
          </div>
          <button type="submit" class="btn btn-outline-dark">
            {{$t('contact.submit')}}
          </button>
        </form>
        <div id="thank-you">
          {{$t('thankYou')}}
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
en:
  slogan: Winter may be coming, but before long you'll get to experience
  description: |
    Can't wait until we launch? Get in touch with our team via the form below or contact us at
  contact:
    name:
      label: Name
      placeholder: Your name
    email:
      label: Email address
      placeholder: you@provider.com
      help: We'll never share your email with anyone else. See our
      privacy: privacy policy
    message:
      label: Everything else
      placeholder: Say hi!
    submit: Submit
  thankYou: Thank you. We will respond to your request as soon as possible.
de:
  slogan: Der Winter mag zwar nahen, doch schon bald erlebst du
  description: |
    Du kannst es nicht mehr abwarten? Schreib unserem Team über das
    Kontaktformular oder unter
  contact:
    name:
      label: Name
      placeholder: Dein Name
    email:
      label: Email-Adresse
      placeholder: du@provider.de
      help: |
        Wir verwenden Deine Email-Adresse nur zur Kontaktaufnahme. Mehr
        Informationen in unserer
      privacy: Datenschutz-Erklärung
    message:
      label: Alles weitere
      placeholder: Deine Nachricht
    submit: Absenden
  thankYou: Vielen Dank! Wir werden uns umgehend bei Dir melden.
</i18n>

<script>

export default {
  name: 'Contact',
  data() {
    return {

    };
  },
  methods: {
    onSubmit: () => {
      document.getElementById('contact').style.display = 'none';
      document.getElementById('thank-you').style.display = 'block';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .contact-form {
    margin-top: 20px;
    margin-bottom: 50px;
  }

  #thank-you {
    display: none;
  }

  .slogan {
    text-align: left;
    color: rgb(119, 141, 126);

    h1 {
      margin-left: 10px;
      font-weight: 200;
    }

    #spring-logo {
      content: url("../../static/images/spring.png");
      height: 150px;
      width: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue